import { CloudCustomer } from "@omni/types/api/customer/cloud/customer.model";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { Country } from "@omni/types/enums/country.enum";
import { Locale } from "@omni/types/enums/locale.enum";
import { ModelMapper } from "@omni/types/utils/modelMapper";
import { isEnum } from "@omni/utils/enum.utils";
import { parsePhoneNumber } from "libphonenumber-js";

import { ComponentsCustomerTypeMapper } from "./shared/enums/customerType.enumMapper";

const parsePhone = (phoneNumber?: string | null) => {
    let phone;
    let phonePrefix;

    if (phoneNumber) {
        try {
            const parsedNumber = parsePhoneNumber(phoneNumber);

            phone = parsedNumber.nationalNumber;
            phonePrefix = parsedNumber.countryCallingCode;
        } catch (_) {}
    }

    return { phone, phonePrefix };
};

const fromCloudToComponents: (
    defaultLocale: Locale
) => ModelMapper<CloudCustomer, ComponentsCustomer> =
    (defaultLocale) => (model) => {
        const { phone, phonePrefix } = parsePhone(model.phone);

        const isB2BClient = !!(model.companyName && model.vatNr);

        return {
            bonusCardRequested: model.bonusCardRequested,
            email: model.email,
            guest: model.guest,
            bonusCardNumber: model.bonusCardNumber,
            eBonusCardNumber: model.eBonusCardNumber,
            firstName: model.firstName,
            requestInvoice: model.requestInvoice,
            favouriteStoreId: model.favouriteStoreId,
            companyName: model.companyName,
            customerType: isB2BClient
                ? ComponentsCustomerType.B2B
                : ComponentsCustomerTypeMapper.fromCloud(model.customerType),
            lastName: model.lastName,
            phone,
            phonePrefix: phonePrefix ? `+${phonePrefix}` : undefined,
            vatNr: model.vatNr?.substring(2),
            vatNrPrefix: model.vatNr?.substring(0, 2) || Country.Be,
            language:
                (isEnum(Locale, model.language) && model.language) ||
                defaultLocale,
            dateOfBirth: model.dateOfBirth,
            receiveSms: model.receiveSms,
            newsLetterSubscribed: model.newsLetterSubscribed,
            cartsMerged: model.cartsMerged,
            hasOrders: model.hasOrders
        };
    };

export const CustomerMapper = {
    fromCloudToComponents
};
